// extracted by mini-css-extract-plugin
export default {"allocating":"Nominations_allocating__9nALw","header":"Nominations_header__LEDWv","filters":"Nominations_filters__IEvEL","filter-row":"Nominations_filter-row__gDQzR"};